import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from '../ExpandedRow/style.module.scss';

const EquipmentTableSkeleton = () => {
  return [...Array(10)].map(() => {
    const rowKey = uuidv4();
    return (
      <tr key={rowKey} className={style.bodyRow}>
        {[...Array(7)].map((_, i) => (
          <td key={`${rowKey}-${i}`}>
            <SkeletonBlock className={style.skeletonText} />
          </td>
        ))}
      </tr>
    );
  });
};

export default EquipmentTableSkeleton;
